import { createRoot } from "react-dom/client";
import ReactRailsUJS from "react_ujs";
import setupAxios from "./axiosConfig";

const nodeToRootMap = new Map();
const RESOLVABLE_EXTENSIONS = [".js", ".jsx", ".ts", ".tsx"];

function buildCompatibleRequireContext(componentRequireContext) {
  const resolveRequest = (request) => {
    const candidates = new Set([request]);

    if (!request.startsWith("./")) {
      candidates.add(`./${request}`);
    }

    Array.from(candidates).forEach((candidate) => {
      RESOLVABLE_EXTENSIONS.forEach((extension) => {
        candidates.add(`${candidate}${extension}`);
      });
    });

    for (const candidate of candidates) {
      if (componentRequireContext.keys().includes(candidate)) {
        return candidate;
      }
    }

    return request;
  };

  const compatibleContext = (request) =>
    componentRequireContext(resolveRequest(request));

  compatibleContext.keys = () => componentRequireContext.keys();
  compatibleContext.resolve = (request) =>
    componentRequireContext.resolve(resolveRequest(request));
  compatibleContext.id = componentRequireContext.id;

  return compatibleContext;
}

if (!ReactRailsUJS.__codexReact18Patched) {
  const originalHandleMount = ReactRailsUJS.handleMount;

  ReactRailsUJS.handleMount = function handleMount(element, props, railsContext) {
    const Component = this.getConstructor(element);
    const reactElement = this.createReactElement(Component, props, railsContext);

    try {
      let root = nodeToRootMap.get(element);
      if (!root) {
        root = createRoot(element);
        nodeToRootMap.set(element, root);
      }
      root.render(reactElement);
    } catch (error) {
      console.error("Error mounting component with React 18:", error);
      originalHandleMount.call(this, element, props, railsContext);
    }
  };

  ReactRailsUJS.__codexReact18Patched = true;
}

let axiosConfigured = false;

export default function bootReactRailsUJS(componentRequireContext) {
  ReactRailsUJS.useContext(
    buildCompatibleRequireContext(componentRequireContext),
  );

  if (!axiosConfigured) {
    setupAxios();
    axiosConfigured = true;
  }
}
